import prop from 'vue-strict-prop'
import { extendFrom } from 'vue-tsx-support'

import Button from '@/components/semantic-ui/Button'
import Modal from '@/components/semantic-ui/Modal'

export default extendFrom(Modal).create({
	name: 'CreateListModal',
	props: {
		value: prop(String).default(''),
	},
	data() {
		return {
			name: '',
		}
	},
	mounted(): void {
		this.$on('hidden', () => this.name = '')
	},
	destroyed(): void {
		this.$off()
	},
	render() {
		const submit = () => this.$emit('input', this.name)

		return (
			<div class="ui tiny modal">
				<div class="header">
					Create List
				</div>
				<div class="content">
					<form class="ui form">
						<div class="field required">
							<label>Name</label>
							<input placeholder="Name" type="text" v-model={this.name} />
						</div>
					</form>
				</div>
				<div class="actions">
					<Button class="cancel">
						Cancel
					</Button>
					<Button class="ok primary" disabled={!this.name} onClick={submit} type="submit">
						Create
					</Button>
				</div>
			</div>
		)
	},
})
